import { render, staticRenderFns } from "./DatePickerB.vue?vue&type=template&id=35330324&scoped=true&"
import script from "./DatePickerB.vue?vue&type=script&lang=js&"
export * from "./DatePickerB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35330324",
  null
  
)

export default component.exports